import {Injectable} from '@angular/core';
import {UsersService} from '../../api/services/users.service';
import {BehaviorSubject} from 'rxjs';
import {
  FaxPhoneNumberModel,
  FaxSummaryReportByDayModel,
  FaxSummaryReportModel, FaxTopNumbersReportModel,
  ReportRequest,
} from '../../api/models';
import {FaxReportService as FaxReportsApiService} from '../../api/services/fax-report.service';

@Injectable()
export class FaxReportsService {

  public summaryList = new BehaviorSubject<FaxSummaryReportModel>(null);
  public summaryListByDay = new BehaviorSubject<Array<FaxSummaryReportByDayModel>>([]);
  public summaryListByPhoneNumber = new BehaviorSubject<Array<FaxTopNumbersReportModel>>([]);
  public faxPhoneNumbers = new BehaviorSubject<Array<FaxPhoneNumberModel>>([]);

  constructor(private apiUserService: UsersService,
              private faxReportsService: FaxReportsApiService,
  ) {

  }

  async getSummaryList(state: ReportRequest): Promise<void> {
    console.log(state);
    const response = await this.faxReportsService.faxReportSummaryReport({body: state}).toPromise();

    this.summaryList.next(response);
  }

  async getSummaryListByDay(state: ReportRequest): Promise<void> {
    console.log(state);
    const response = await this.faxReportsService.faxReportSummaryReportByDay({body: state}).toPromise();

    this.summaryListByDay.next(response);
  }

  async getSummaryListByPhoneNumber(state: ReportRequest): Promise<void> {
    console.log(state);
    const response = await this.faxReportsService.faxReportGetTopNumbersReport({body: state}).toPromise();

    this.summaryListByPhoneNumber.next(response);
  }

  async getMyMessagingPhoneNumbers(): Promise<void> {
    const response = await this.faxReportsService.faxReportGetFaxPhoneNumbers().toPromise();

    this.faxPhoneNumbers.next(response);
  }
}
